<template>
  <div>
    <label class="block font-semibold text-sm text-dark mb-1">
      {{ label }}
      <span v-if="required" class="text-primary">*</span>
    </label>
    <slot />
    <p v-if="help" class="text-xs text-dark opacity-60 mt-1">{{ help }}</p>
  </div>
</template>

<script>
export default {
  name: 'FormField',
  props: {
    label: { type: String, required: true },
    required: { type: Boolean, default: false },
    help: { type: String, default: '' }
  }
};
</script>
